interface LogoProps {
  width?: number
  height?: number
  color?: string
  className?: string
}

export function Logo({
  width = 60,
  height = 57,
  color = 'white',
  className
}: LogoProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 60 57'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-label='Coolmate Logo'
      role='img'
    >
      <path
        d='M59.293 25.7959L53.874 37.3857H37.0645C35.6371 37.3857 33.9392 38.5399 33.2734 39.9639L25.4346 56.7275H13.7969L22.8418 37.3857C25.8351 30.9849 33.4651 25.7959 39.8838 25.7959H59.293ZM45.4951 0L36.4512 19.3408C33.458 25.7418 25.828 30.9316 19.4092 30.9316H0L5.41895 19.3408H22.2295C23.6569 19.3406 25.3549 18.1867 26.0205 16.7627L33.8584 0H45.4951Z'
        fill={color}
      />
    </svg>
  )
}
